import TopRankUniCard from "@modules/study/common/top_rank_uni_card";
import API from "@unisearch/helpers/api";
import Link from "next/link";
import { getAssets } from "@unisearch/helpers";
import React, { Fragment, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import BannerBox from "./components/banner_box";
import styles from "./explore_list.module.scss";

export const ExploreList = ({ allExploreData, allCountry }) => {
  const [hasMore, setHasMore] = useState(true);
  const [allExploreCountryData, setAllExploreCountryData] = useState(
    allExploreData
  );
  const [page, setPage] = useState(2);

  const getMoreData = async () => {
    setPage(page + 1);
    const exploreAPI = `/public/university/explore-university?isTop=true&page=${page}`;
    let getMoreCountryData = await API.get(exploreAPI);
    if (!getMoreCountryData.error && getMoreCountryData.data.length > 0) {
      setAllExploreCountryData((data) => [...data, ...getMoreCountryData.data]);
    } else {
      setHasMore(false);
    }
  };

  return (
    <Fragment>
      {allExploreCountryData?.length > 0 && (
        <InfiniteScroll
          dataLength={allExploreCountryData.length}
          next={getMoreData}
          hasMore={hasMore}
          loader={<small> Loading...</small>}
        >
          <section className={styles.section_explore_list}>
            <div className="">
              <div className={styles.wrapper}>
                <ul className={styles.explore_list}>
                  {allExploreCountryData.map((country, i) => {
                    if (country?.universityData?.length > 0) {
                      return (
                        <Fragment key={i}>
                          {country?.universityData?.length > 0 && (
                            <li>
                              <BannerBox
                                image={
                                  country?.src ||
                                  getAssets(
                                    "assets/images/image_placeholder_big.webp"
                                  )
                                }
                                alt={country?.name}
                                title={country?.name}
                                university={country?.totalUni}
                                courses={country?.totalCourse}
                              />

                              <div className={styles.title_wrapper}>
                                <h3>{country?.name}'s Top 10 Universities</h3>
                                <Link
                                  legacyBehavior
                                  href={`/${country?.slug}/university`}
                                >
                                  <a className={styles.link}>
                                    View all universities ›
                                  </a>
                                </Link>
                              </div>

                              {country?.universityData?.length > 0 && (
                                <div className={styles.uni_box_wrapper}>
                                  {country?.universityData?.map((item, i) => {
                                    return (
                                      <TopRankUniCard key={i} data={item} />
                                    );
                                  })}
                                </div>
                              )}
                            </li>
                          )}
                        </Fragment>
                      );
                    }
                  })}
                </ul>
              </div>
            </div>
          </section>
        </InfiniteScroll>
      )}
    </Fragment>
  );
};

export default ExploreList;
